import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { getMergedClassNames } from '../../utils/HTMLUtils';
import styles from './MessageLayer.scss';
const rootClassName = styles.rootClassName;

export const MESSAGE_LAYER_INFO_THEME = 'info';
export const MESSAGE_LAYER_SUCCESS_THEME = 'success';
export const MESSAGE_LAYER_ERROR_THEME = 'error';

class MessageLayer extends Component {
  getThemeClassName = () => {
    const theme = this.props.theme || '';
    switch (theme.toLowerCase()) {
      case MESSAGE_LAYER_SUCCESS_THEME:
      case MESSAGE_LAYER_ERROR_THEME:
        return theme.toLowerCase();
      default:
        return MESSAGE_LAYER_INFO_THEME;
    }
  };

  render() {
    const theme = this.getThemeClassName();
    return (
      <div
        className={getMergedClassNames([
          rootClassName,
          rootClassName + '-' + theme,
          this.props.className || '',
        ])}
      >
        {this.props.text}
      </div>
    );
  }
}

MessageLayer.propTypes = {
  text: PropTypes.string.isRequired,
  theme: PropTypes.string,
};

export default MessageLayer;
